import { InventoryNameType } from '../../constants';

export const miningEquipmentNames = [
    'Сutter',
    'Delaminator',
    'DME Wire',
    'Plunging Blocks',
    'Wandering Reactor',
] as InventoryNameType[];
